import { syncIconCardStackOffset } from "../shared/icon-card-offset.js";

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".icon-cards-to-sliders");
  const MOBILE_BREAKPOINT = 768;
  const DESKTOP_BREAKPOINT = 992;
  const MAX_CARD_WIDTH = 318;
  const MOBILE_GAP = 16;
  const TABLET_GAP = 20;
  const DESKTOP_GAP = 15;
  const DESKTOP_VISIBLE_FLOOR = 5;
  const TABLET_VISIBLE_FLOOR = 3;

  sections.forEach((section) => {
    const cardSwiper = section.querySelector(".icon-cards-swiper");
    if (!cardSwiper) return;

    const slides = cardSwiper.querySelectorAll(".swiper-slide");
    const wrappers = section.querySelectorAll(".inner-wrapper");
    const prevEl = section.querySelector(".swiper-controls .prev");
    const nextEl = section.querySelector(".swiper-controls .next");
    const hasMultipleSlides = slides.length > 1;
    const controlsEl = section.querySelector(".swiper-controls");
    const iconImages = section.querySelectorAll(".icon-area img");

    let swiperInstance = null;
    let heightSyncFrame = null;

    function getCurrentGap() {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) return DESKTOP_GAP;
      if (window.innerWidth >= MOBILE_BREAKPOINT) return TABLET_GAP;
      return MOBILE_GAP;
    }

    function setCardWidth() {
      const slideCount = slides.length;
      const availableWidth = Math.max(cardSwiper.clientWidth, 0);
      const gap = getCurrentGap();
      let cardWidth = MAX_CARD_WIDTH;

      if (window.innerWidth < MOBILE_BREAKPOINT) {
        cardWidth = Math.min(MAX_CARD_WIDTH, Math.max(availableWidth - 32, 0));
      } else if (window.innerWidth < DESKTOP_BREAKPOINT) {
        const fitAllWidth =
          (availableWidth - gap * Math.max(slideCount - 1, 0)) / slideCount;
        const threeUpWidth =
          (availableWidth - gap * (TABLET_VISIBLE_FLOOR - 1)) /
          TABLET_VISIBLE_FLOOR;

        cardWidth = Math.min(
          MAX_CARD_WIDTH,
          Math.max(fitAllWidth, threeUpWidth),
        );
      } else {
        const fitAllWidth =
          (availableWidth - gap * Math.max(slideCount - 1, 0)) / slideCount;
        const fiveUpWidth =
          (availableWidth - gap * (DESKTOP_VISIBLE_FLOOR - 1)) /
          DESKTOP_VISIBLE_FLOOR;

        cardWidth = Math.min(
          MAX_CARD_WIDTH,
          Math.max(fitAllWidth, fiveUpWidth),
        );
      }

      section.style.setProperty("--icon-card-width", `${cardWidth}px`);
    }

    function syncCardHeights() {
      syncIconCardStackOffset(section, wrappers, {
        uniformHeightProperty: "--icon-card-uniform-height",
        offsetProperty: "--icon-card-icon-offset",
      });
    }

    function scheduleHeightSync() {
      if (heightSyncFrame) {
        cancelAnimationFrame(heightSyncFrame);
      }

      heightSyncFrame = requestAnimationFrame(() => {
        syncCardHeights();
        heightSyncFrame = null;
      });
    }

    function updateControls() {
      if (!controlsEl) return;

      const isOverflowing = Boolean(
        swiperInstance && hasMultipleSlides && !swiperInstance.isLocked,
      );

      controlsEl.classList.toggle("is-hidden", !isOverflowing);
    }

    function initSwiper() {
      if (swiperInstance) return;

      setCardWidth();

      swiperInstance = new Swiper(cardSwiper, {
        loop: false,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: MOBILE_GAP,
        speed: 800,
        autoplay: false,
        allowTouchMove: hasMultipleSlides,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation:
          hasMultipleSlides && prevEl && nextEl
            ? { nextEl, prevEl }
            : undefined,
        breakpoints: {
          768: {
            centeredSlides: false,
            spaceBetween: TABLET_GAP,
          },
          992: {
            centeredSlides: false,
            spaceBetween: DESKTOP_GAP,
          },
        },
        on: {
          init() {
            updateControls();
            scheduleHeightSync();
          },
          resize() {
            updateControls();
            scheduleHeightSync();
          },
          update() {
            updateControls();
            scheduleHeightSync();
          },
          lock: updateControls,
          unlock: updateControls,
        },
      });
    }

    function handleResize() {
      setCardWidth();

      if (!swiperInstance) {
        initSwiper();
        return;
      }

      swiperInstance.update();
      updateControls();
      scheduleHeightSync();
    }

    initSwiper();
    updateControls();
    scheduleHeightSync();
    iconImages.forEach((image) => {
      if (image.complete) return;

      image.addEventListener("load", scheduleHeightSync, { once: true });
    });
    window.addEventListener("load", scheduleHeightSync);
    window.addEventListener("resize", handleResize);
  });
});
